// extracted by mini-css-extract-plugin
module.exports = {"container":"Welcome_container__3aiE8","welcome-prompt":"Welcome_welcome-prompt__2ofgZ"};